import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { NavigationService } from '../../services/navigation.service';
import { ProgramaService } from '../../services/programa.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-programa-view',
  templateUrl: './programa-view.component.html',
  styleUrls: ['./programa-view.component.scss']
})
export class ProgramaViewComponent extends BaseListComponent<ProjetoCadastro> implements OnInit, OnDestroy {

  idPrograma: number;
  programa: ProjetoCadastro;

  constructor(
    private myService: ProgramaService,
    private toastr: ToastrService,
    private navigation: NavigationService,
    private activatedRoute: ActivatedRoute,
  ) {
    super()
  }

  ngOnInit(): void {
    this.idPrograma = this.activatedRoute.snapshot.parent.parent.params?.idProjeto;
    this.loaded();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  voltar() {
    this.navigation.back(['projetos', 'programa']);
  }

  editar() {
    return ['/projetos', 'programa', this.idPrograma, 'cadastro', 'editar'];
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir() {
    this.loading();
    this.myService.delete(this.idPrograma).subscribe({
      next: (res) => {
        this.toastr.info('Programa excluído com sucesso!');
        this.voltar();
      },
      error: (error) => {
        this.msgError(error?.error?.message);
        this.loaded();
      }
    });
  }

}
